import { ReactNode } from "react";
import { Helmet } from "react-helmet-async";
import Header from "./Header";
import Footer from "./Footer";
import { SITE_URL } from "@/lib/constants";
import { OG_IMAGE_DEFAULT } from "@/lib/r2-assets";

interface LayoutProps {
  children: ReactNode;
}

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Or Brasil",
  "url": SITE_URL,
  "logo": OG_IMAGE_DEFAULT,
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+55-11-3803-7000",
    "contactType": "customer service",
    "availableLanguage": "Portuguese"
  },
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Rua Dr. Rubens Meireles, 148",
    "addressLocality": "São Paulo",
    "addressRegion": "SP",
    "postalCode": "01141-000",
    "addressCountry": "BR"
  },
  "sameAs": [
    "https://www.instagram.com/orbrasil_fixacao",
    "https://www.youtube.com/@orbrasil_oficial",
    "https://www.linkedin.com/company/orbrasil/",
    "https://www.facebook.com/orbrasilfixacao"
  ]
};

/**
 * The site shell: Header, <main>, Footer. Rendered once per visit by the
 * router (SiteShell in routes-client.tsx) and by Preview, which is routed
 * outside it. Pages must not wrap themselves in it: that would nest a
 * second Header and Footer inside <main>.
 */
const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      </Helmet>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[200] focus:bg-primary focus:text-primary-foreground focus:px-4 focus:py-2 focus:rounded-lg focus:font-semibold focus:shadow-lg"
      >
        Pular para o conteúdo principal
      </a>
      <Header />
      <main id="main-content" className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
